exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".participant-image[data-v-1f56b09a]{max-width:175px;border-radius:100px}", ""]);

// exports
